(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["SH-mobile-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    var menu = document.getElementById('SH-mobile-menu');
    if (!menu || menu.dataset.shBound === 'true') return;
    menu.dataset.shBound = 'true';

    var menuFade = menu.querySelector('.SH-mobile-menu__fade');
    var menuScrollbar = menu.querySelector('.SH-mobile-menu__scrollbar');
    var menuScrollbarThumb = menu.querySelector('.SH-mobile-menu__scrollbar-thumb');

    function activeMenuPanel() {
      return menu.querySelector('.SH-mobile-menu__panel.is-open') || menu.querySelector('.SH-mobile-menu__panel:not(.is-nested)');
    }

    function updateMenuFade() {
      var scrollPanel = activeMenuPanel();
      if (!scrollPanel) return;
      var canScroll = scrollPanel.scrollHeight - scrollPanel.clientHeight > 8;
      var atBottom = scrollPanel.scrollTop + scrollPanel.clientHeight >= scrollPanel.scrollHeight - 8;
      if (menuFade) menuFade.hidden = !canScroll || atBottom;
      if (!menuScrollbar || !menuScrollbarThumb) return;
      menuScrollbar.hidden = !canScroll;
      if (!canScroll) return;
      var trackHeight = menuScrollbar.clientHeight;
      var thumbHeight = Math.min(104, trackHeight);
      var maxOffset = Math.max(trackHeight - thumbHeight, 0);
      var scrollRange = scrollPanel.scrollHeight - scrollPanel.clientHeight;
      var offset = scrollRange > 0 ? (scrollPanel.scrollTop / scrollRange) * maxOffset : 0;
      menuScrollbarThumb.style.height = thumbHeight + 'px';
      menuScrollbarThumb.style.transform = 'translateY(' + offset + 'px)';
    }

    menu.querySelectorAll('.SH-mobile-menu__panel').forEach(function (scrollPanel) {
      scrollPanel.addEventListener('scroll', updateMenuFade, { passive: true });
    });
    updateMenuFade();

    function closeLocaleDropdowns() {
      menu.querySelectorAll('.SH-mobile-menu__locale-dropdown[open]').forEach(function (dropdown) {
        dropdown.removeAttribute('open');
      });
    }

    menu.querySelectorAll('.SH-mobile-menu__locale-dropdown').forEach(function (dropdown) {
      dropdown.addEventListener('toggle', function () {
        if (!dropdown.open) return;
        menu.querySelectorAll('.SH-mobile-menu__locale-dropdown[open]').forEach(function (other) {
          if (other !== dropdown) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', function (event) {
      var openDropdown = menu.querySelector('.SH-mobile-menu__locale-dropdown[open]');
      if (!openDropdown || openDropdown.contains(event.target)) return;
      closeLocaleDropdowns();
    });

    if (menu.parentNode !== document.body) {
      document.body.appendChild(menu);
    }

    var toggles = document.querySelectorAll('[aria-controls="SH-mobile-menu"]');
    var widgetSelector = 'shopify-chat, pandectes-cmp, .cc-window, .cc-revoke, #shopify-pc__banner, #shopify-privacy-banner';

    function hideWidgets() {
      document.querySelectorAll(widgetSelector).forEach(function (el) {
        if (el.style.getPropertyValue('display') === 'none' && el.style.getPropertyPriority('display') === 'important') return;
        if (el.dataset.shPrevDisplay === undefined) {
          el.dataset.shPrevDisplay = el.style.getPropertyValue('display');
          el.dataset.shPrevPriority = el.style.getPropertyPriority('display');
        }
        el.style.setProperty('display', 'none', 'important');
      });
    }

    function showWidgets() {
      document.querySelectorAll(widgetSelector).forEach(function (el) {
        if (el.dataset.shPrevDisplay === undefined) return;
        if (el.dataset.shPrevDisplay) {
          el.style.setProperty('display', el.dataset.shPrevDisplay, el.dataset.shPrevPriority || '');
        } else {
          el.style.removeProperty('display');
        }
        delete el.dataset.shPrevDisplay;
        delete el.dataset.shPrevPriority;
      });
    }

    function headerSection() {
      return document.querySelector('.shopify-section__header');
    }

    function pinStickyHeader() {
      var header = headerSection();
      if (!header || header.getBoundingClientRect().top > 1) return;
      header.dataset.shPinned = 'true';
      header.style.position = 'fixed';
      header.style.top = '0';
      header.style.left = '0';
      header.style.right = '0';
      header.style.width = '100%';
      header.style.zIndex = '1990';
    }

    function unpinStickyHeader() {
      var header = headerSection();
      if (!header || header.dataset.shPinned !== 'true') return;
      header.style.position = '';
      header.style.top = '';
      header.style.left = '';
      header.style.right = '';
      header.style.width = '';
      header.style.zIndex = '';
      delete header.dataset.shPinned;
    }

    function setOpen(open) {
      if (open) pinStickyHeader();
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.documentElement.classList.toggle('SH-mobile-menu-open', open);

      if (open) {
        hideWidgets();
        requestAnimationFrame(updateMenuFade);
      } else {
        showWidgets();
        unpinStickyHeader();
      }

      if (!open) {
        menu.querySelectorAll('.SH-mobile-menu__panel.is-open').forEach(function (panel) {
          panel.classList.remove('is-open');
        });
        menu.querySelectorAll('[data-action="sh-open-panel"][aria-expanded="true"]').forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
        resetSearch();
      }
    }

    var form = menu.querySelector('.SH-search');
    var input = form ? form.querySelector('[name="q"]') : null;
    var panel = form ? form.querySelector('.SH-search__panel') : null;
    var results = form ? form.querySelector('.SH-search__results') : null;
    var resultsInner = form ? form.querySelector('.SH-search__results-inner') : null;
    var quickLinks = form ? form.querySelector('.SH-search__menu') : null;
    var clearButton = form ? form.querySelector('[data-action="sh-clear-search"]') : null;
    var searchTimer = null;
    var lastQuery = '';

    function searchRoot() {
      var root = (form && form.getAttribute('data-search-root')) || '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function supportsPredictiveSearch() {
      var features = document.getElementById('shopify-features');
      if (!features) return false;
      try {
        return JSON.parse(features.innerHTML).predictiveSearch === true;
      } catch (error) {
        return false;
      }
    }

    function hideSearchPanel() {
      if (panel) panel.hidden = true;
      if (results) results.setAttribute('aria-hidden', 'true');
      if (quickLinks) quickLinks.hidden = true;
      if (form) form.classList.remove('is-loading');
    }

    function resetSearch() {
      lastQuery = '';
      if (input) {
        input.value = '';
        input.classList.remove('is-filled');
      }
      if (clearButton) clearButton.hidden = true;
      if (resultsInner) resultsInner.innerHTML = '';
      hideSearchPanel();
    }

    function showQuickLinks() {
      if (!panel || !quickLinks) {
        hideSearchPanel();
        return;
      }
      panel.hidden = false;
      quickLinks.hidden = false;
      if (results) results.setAttribute('aria-hidden', 'true');
    }

    function runSearch() {
      if (!input || !results || !resultsInner) return;
      var query = input.value;
      lastQuery = query;
      input.classList.toggle('is-filled', query !== '');
      if (clearButton) clearButton.hidden = query === '';

      if (query === '') {
        resultsInner.innerHTML = '';
        if (form) form.classList.remove('is-loading');
        showQuickLinks();
        return;
      }

      if (quickLinks) quickLinks.hidden = true;
      if (panel) panel.hidden = false;
      results.setAttribute('aria-hidden', 'false');
      if (form) form.classList.add('is-loading');

      var root = searchRoot();
      var endpoint = root + 'search' + (supportsPredictiveSearch() ? '/suggest' : '');
      var requestUrl = endpoint + '?section_id=predictive-search&q=' + encodeURIComponent(query) + '&resources[limit]=3&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';

      fetch(requestUrl, { method: 'GET', credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (lastQuery !== query) return;
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var ajax = holder.querySelector('.search-ajax');
          resultsInner.innerHTML = ajax ? ajax.innerHTML : '';
          if (form) form.classList.remove('is-loading');
        })
        .catch(function () {
          if (lastQuery !== query) return;
          if (form) form.classList.remove('is-loading');
        });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(menu.getAttribute('aria-hidden') !== 'false');
      });
    });

    if (input) {
      input.addEventListener('focus', function () {
        if (input.value === '') {
          showQuickLinks();
        } else if (resultsInner && resultsInner.innerHTML !== '') {
          if (panel) panel.hidden = false;
          if (results) results.setAttribute('aria-hidden', 'false');
        }
      });

      input.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(runSearch, 250);
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        if (!input || input.value === '') return;
        input.classList.add('is-filled');
      });
    }

    menu.addEventListener('click', function (event) {
      if (event.target === menu) {
        setOpen(false);
        return;
      }

      if (form && !form.contains(event.target)) {
        hideSearchPanel();
      }

      if (event.target.closest('[data-action="sh-clear-search"]')) {
        event.preventDefault();
        resetSearch();
        if (input) input.focus();
        return;
      }

      if (event.target.closest('[data-action="sh-close-menu"]')) {
        event.preventDefault();
        setOpen(false);
        return;
      }

      var openButton = event.target.closest('[data-action="sh-open-panel"]');
      if (openButton && menu.contains(openButton)) {
        event.preventDefault();
        closeLocaleDropdowns();
        var panel = document.getElementById(openButton.getAttribute('aria-controls'));
        if (panel) {
          var parentPanel = openButton.closest('.SH-mobile-menu__panel');
          if (parentPanel) parentPanel.dataset.shScroll = String(parentPanel.scrollTop);
          openButton.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
          requestAnimationFrame(updateMenuFade);
        }
        return;
      }

      var closeButton = event.target.closest('[data-action="sh-close-panel"]');
      if (closeButton && menu.contains(closeButton)) {
        event.preventDefault();
        var panelToClose = closeButton.closest('.SH-mobile-menu__panel.is-open');
        if (!panelToClose) return;
        panelToClose.classList.remove('is-open');
        panelToClose.scrollTop = 0;
        var opener = menu.querySelector('[aria-controls="' + panelToClose.id + '"]');
        if (opener) {
          opener.setAttribute('aria-expanded', 'false');
          var previousPanel = opener.closest('.SH-mobile-menu__panel');
          if (previousPanel && previousPanel.dataset.shScroll) {
            var savedScroll = Number(previousPanel.dataset.shScroll);
            var restoreScroll = function () {
              previousPanel.scrollTop = savedScroll;
            };
            restoreScroll();
            requestAnimationFrame(function () {
              restoreScroll();
              requestAnimationFrame(function () {
                restoreScroll();
                updateMenuFade();
              });
            });
          }
        }
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') {
        setOpen(false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-combining"] && !Shopify.designMode) return;
  try {
    (function () {
    var GAP = 8;
    var PEEK = 0.55; /* visible share of cards 5–6 */
    var FADE_ZONE = 56; /* extra depth under peek for CTA + deep fade */

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function syncPeekHeight(wrap) {
      var body = wrap.querySelector('.product-redesign__combining-body');
      var card = wrap.querySelector('.product-redesign__combining-card');
      if (!body) return;

      if (isDesktop() || !wrap.classList.contains('has-more') || wrap.classList.contains('is-expanded')) {
        body.style.maxHeight = '';
        return;
      }

      if (!card) return;
      var h = card.getBoundingClientRect().height;
      if (!h) return;
      /* 2 full rows + peek of 5–6 + deep fade/CTA zone */
      body.style.maxHeight = h * 2 + GAP * 2 + h * PEEK + FADE_ZONE + 'px';
    }

    function initCombining(wrap) {
      if (!wrap || wrap.dataset.combiningReady === '1') return;
      wrap.dataset.combiningReady = '1';

      var toggle = wrap.querySelector('[data-product-redesign-combining-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var expanded = wrap.classList.toggle('is-expanded');
          toggle.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
          syncPeekHeight(wrap);
        });
      }

      syncPeekHeight(wrap);
      requestAnimationFrame(function () {
        syncPeekHeight(wrap);
      });
      window.addEventListener('load', function () {
        syncPeekHeight(wrap);
      });
      window.addEventListener('resize', function () {
        syncPeekHeight(wrap);
      });

      wrap.querySelectorAll('[data-product-redesign-combining-qty]').forEach(function (qtyWrap) {
        var input = qtyWrap.querySelector('.product-redesign__combining-qty-input');
        if (!input) return;

        qtyWrap.querySelectorAll('[data-qty-action]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var value = parseInt(input.value, 10) || 1;
            var min = parseInt(input.min, 10) || 1;
            var max = parseInt(input.max, 10) || 99;
            if (btn.getAttribute('data-qty-action') === 'minus') {
              value = Math.max(min, value - 1);
            } else {
              value = Math.min(max, value + 1);
            }
            input.value = value;
          });
        });
      });

      wrap.querySelectorAll('[data-product-redesign-combining-form]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var submitBtn = form.querySelector('[type="submit"]');
          var icon = submitBtn && submitBtn.querySelector('.product-redesign__combining-atc-icon');
          var cartSrc = submitBtn && submitBtn.getAttribute('data-icon-cart');
          var addedSrc = submitBtn && submitBtn.getAttribute('data-icon-added');
          if (!submitBtn || submitBtn.classList.contains('is-loading')) return;

          submitBtn.disabled = true;
          submitBtn.classList.remove('is-added');
          submitBtn.classList.add('is-loading');
          submitBtn.setAttribute('aria-busy', 'true');
          if (icon && cartSrc) icon.src = cartSrc;

          var formData = new FormData(form);
          fetch(form.action, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/javascript' }
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Add to cart failed');
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
              submitBtn.classList.remove('is-loading');
              submitBtn.removeAttribute('aria-busy');
              if (icon && addedSrc) {
                submitBtn.classList.add('is-added');
                icon.src = addedSrc;
                window.setTimeout(function () {
                  submitBtn.classList.remove('is-added');
                  if (cartSrc) icon.src = cartSrc;
                  submitBtn.disabled = false;
                }, 1200);
              } else {
                submitBtn.disabled = false;
              }
            })
            .catch(function () {
              submitBtn.classList.remove('is-loading', 'is-added');
              submitBtn.removeAttribute('aria-busy');
              if (icon && cartSrc) icon.src = cartSrc;
              submitBtn.disabled = false;
              form.submit();
            });
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-product-redesign-combining]').forEach(initCombining);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-description"] && !Shopify.designMode) return;
  try {
    (function () {
    function stripTitleEmojis(root) {
      root.querySelectorAll('.product-redesign__accordion-title').forEach(function (el) {
        var text = el.textContent || '';
        text = text
          .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]/gu, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (text) el.textContent = text;
      });
    }

    function openItem(item) {
      if (!item) return;
      var btn = item.querySelector('[data-product-redesign-accordion-trigger]');
      var panel = item.querySelector('.product-redesign__accordion-panel');
      item.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    }

    function closeAll(root) {
      root.querySelectorAll('[data-product-redesign-accordion-item]').forEach(function (other) {
        var otherBtn = other.querySelector('[data-product-redesign-accordion-trigger]');
        var otherPanel = other.querySelector('.product-redesign__accordion-panel');
        other.classList.remove('is-open');
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        if (otherPanel) otherPanel.hidden = true;
      });
    }

    function applyInitialState(root) {
      closeAll(root);
      /* Mobile: first panel open · Desktop: all closed */
      if (window.matchMedia('(max-width: 749px)').matches) {
        openItem(root.querySelector('[data-product-redesign-accordion-first]'));
      }
    }

    function initAccordion(root) {
      if (!root || root.dataset.accordionReady === '1') return;
      root.dataset.accordionReady = '1';
      stripTitleEmojis(root);
      applyInitialState(root);

      root.querySelectorAll('[data-product-redesign-accordion-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-product-redesign-accordion-item]');
          if (!item) return;
          var open = item.classList.contains('is-open');
          closeAll(root);
          if (!open) openItem(item);
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-product-redesign-accordion]').forEach(initAccordion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(gallery) {
      if (!gallery || gallery.dataset.galleryReady === '1') return;
      gallery.dataset.galleryReady = '1';

      var slides = Array.prototype.slice.call(
        gallery.querySelectorAll('.product-redesign__gallery-slide')
      );
      var thumbsTrack = gallery.querySelector('[data-product-redesign-thumbs]');
      var thumbsNav = gallery.querySelector('[data-product-redesign-thumbs-nav]');
      var thumbsPrev = gallery.querySelector('[data-product-redesign-thumbs-prev]');
      var thumbsNext = gallery.querySelector('[data-product-redesign-thumbs-next]');
      var thumbs = Array.prototype.slice.call(
        gallery.querySelectorAll('[data-product-redesign-thumbs] .product-redesign__thumb')
      );
      var counterCurrent = gallery.querySelector('[data-product-redesign-counter-current]');

      function updateThumbsArrows() {
        if (!thumbsTrack || !thumbsNav) return;
        var maxScroll = thumbsTrack.scrollWidth - thumbsTrack.clientWidth;
        var scrollable = maxScroll > 4;
        thumbsNav.classList.toggle('is-scrollable', scrollable);
        if (thumbsPrev) {
          thumbsPrev.hidden = !scrollable;
          thumbsPrev.disabled = thumbsTrack.scrollLeft <= 2;
        }
        if (thumbsNext) {
          thumbsNext.hidden = !scrollable;
          thumbsNext.disabled = thumbsTrack.scrollLeft >= maxScroll - 2;
        }
      }

      function scrollThumbs(direction) {
        if (!thumbsTrack) return;
        var step = Math.max(thumbsTrack.clientWidth * 0.75, 160);
        thumbsTrack.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      function scrollActiveThumbIntoView() {
        if (!thumbsTrack) return;
        var activeThumb = thumbsTrack.querySelector('.product-redesign__thumb.is-active');
        if (!activeThumb || typeof activeThumb.scrollIntoView !== 'function') return;
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }

      function pauseMedia(scope) {
        if (!scope) return;
        scope.querySelectorAll('video').forEach(function (video) {
          try {
            video.pause();
          } catch (e) {
            /* no-op */
          }
        });
        scope.querySelectorAll('iframe').forEach(function (iframe) {
          try {
            if (!iframe.contentWindow) return;
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
              '*'
            );
            iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
          } catch (e) {
            /* no-op */
          }
        });
      }

      function enableVideoIframes(slide) {
        if (!slide) return;
        slide.querySelectorAll('iframe').forEach(function (iframe) {
          if (!iframe.getAttribute('src') && iframe.getAttribute('data-src')) {
            iframe.setAttribute('src', iframe.getAttribute('data-src'));
          }
          iframe.style.pointerEvents = 'auto';
          /* enable JS API so pause works when switching thumbs */
          var src = iframe.getAttribute('src') || '';
          if (src && src.indexOf('youtube') !== -1 && src.indexOf('enablejsapi=1') === -1) {
            iframe.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'enablejsapi=1');
          }
        });
      }

      function activate(mediaId) {
        var index = 1;
        var activeSlide = null;
        slides.forEach(function (slide) {
          var active = String(slide.getAttribute('data-media-id')) === String(mediaId);
          if (!active) pauseMedia(slide);
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          if (active) {
            index = Number(slide.getAttribute('data-index')) || 1;
            activeSlide = slide;
          }
        });
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle(
            'is-active',
            String(thumb.getAttribute('data-media-id')) === String(mediaId)
          );
        });
        if (counterCurrent) counterCurrent.textContent = String(index);
        if (activeSlide) enableVideoIframes(activeSlide);
        gallery.classList.toggle(
          'is-media-video',
          !!(activeSlide && activeSlide.querySelector('[data-media-type="external_video"], [data-media-type="video"]'))
        );
        scrollActiveThumbIntoView();
        updateThumbsArrows();
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activate(thumb.getAttribute('data-media-id'));
        });
      });

      if (thumbsPrev) {
        thumbsPrev.addEventListener('click', function () {
          scrollThumbs(-1);
        });
      }
      if (thumbsNext) {
        thumbsNext.addEventListener('click', function () {
          scrollThumbs(1);
        });
      }
      if (thumbsTrack) {
        thumbsTrack.addEventListener('scroll', updateThumbsArrows, { passive: true });
        window.addEventListener('resize', updateThumbsArrows);
      }

      var initial =
        gallery.querySelector('.product-redesign__gallery-slide.is-active') || slides[0];
      if (initial) activate(initial.getAttribute('data-media-id'));
      updateThumbsArrows();

      document.addEventListener('variant:changed', function (event) {
        try {
          var variant = event.detail && (event.detail.variant || event.detail);
          if (!variant || !variant.featured_media) return;
          activate(variant.featured_media.id);
        } catch (e) {
          /* no-op */
        }
      });
    }

    function initEekModal(scope) {
      if (!scope || scope.dataset.eekModalReady === '1') return;
      var modalEl = scope.querySelector('[data-product-redesign-eek-modal]');
      if (!modalEl) return;
      scope.dataset.eekModalReady = '1';

      function openModal() {
        modalEl.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }

      function closeModal() {
        modalEl.hidden = true;
        document.documentElement.style.overflow = '';
      }

      scope.querySelectorAll('[data-product-redesign-eek-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          openModal();
        });
      });

      modalEl.querySelectorAll('[data-product-redesign-eek-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modalEl.hidden) closeModal();
      });
    }

    function initVideoModal(scope) {
      if (!scope || scope.dataset.videoModalReady === '1') return;
      var modalEl = scope.querySelector('[data-product-redesign-video-modal]');
      if (!modalEl) return;
      scope.dataset.videoModalReady = '1';
      var videoEl = modalEl.querySelector('[data-product-redesign-video-el]');
      var playBtn = modalEl.querySelector('[data-product-redesign-video-play]');

      function syncPlay() {
        if (playBtn && videoEl) playBtn.hidden = !videoEl.paused;
      }

      function openModal() {
        modalEl.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (videoEl) { var p = videoEl.play(); if (p) p.catch(function () {}); }
      }
      function closeModal() {
        modalEl.hidden = true;
        document.documentElement.style.overflow = '';
        if (videoEl && videoEl.pause) { try { videoEl.pause(); } catch (e) {} }
      }

      if (videoEl) {
        videoEl.addEventListener('play', syncPlay);
        videoEl.addEventListener('pause', syncPlay);
        videoEl.addEventListener('ended', syncPlay);
      }
      if (playBtn && videoEl) {
        playBtn.addEventListener('click', function () { videoEl.play(); });
      }

      scope.querySelectorAll('[data-product-redesign-video-open]').forEach(function (btn) {
        btn.addEventListener('click', openModal);
      });
      modalEl.querySelectorAll('[data-product-redesign-video-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modalEl.hidden) closeModal();
      });
    }

    function initGalleryZoom(gallery) {
      if (!gallery || gallery.dataset.zoomReady === '1') return;
      var stage = gallery.querySelector('[data-product-redesign-stage]');
      if (!stage) return;
      gallery.dataset.zoomReady = '1';

      function activeImg() {
        var slide = stage.querySelector('.product-redesign__gallery-slide.is-active');
        return slide ? slide.querySelector('.product-redesign__gallery-image') : null;
      }

      stage.addEventListener('mousemove', function (e) {
        if (!window.matchMedia('(hover: hover)').matches) return;
        var img = activeImg();
        if (!img) return;
        var rect = img.getBoundingClientRect();
        if (!rect.width) return;
        var x = Math.max(0, Math.min(100, (e.clientX - rect.left) / rect.width * 100));
        var y = Math.max(0, Math.min(100, (e.clientY - rect.top) / rect.height * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.setProperty('transform', 'scale(2)', 'important');
      });
      stage.addEventListener('mouseleave', function () {
        var img = activeImg();
        if (img) img.style.removeProperty('transform');
      });
    }

    function boot() {
      document.querySelectorAll('[data-product-redesign-gallery]').forEach(initGallery);
      document.querySelectorAll('[data-product-redesign-gallery]').forEach(initGalleryZoom);
      document.querySelectorAll('[data-product-redesign]').forEach(initEekModal);
      document.querySelectorAll('[data-product-redesign]').forEach(initVideoModal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
